import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as display from '../feature'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Owns global toast state and toaster-related side effects.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'toaster',
      parent: display.FEATURE,
      selectors: () => new Selectors(this),
    })

    this.registerEffects(
      effects.actionClicked(),
      effects.autoDismiss(),
      effects.graphqlRetry(),
    )
  }
}
